<template>
	<!-- 基本信息 -->
	<div class="Minister-top information">
		<div class="Minister-top-top Ministerbackground">
			<div class="Minister-top-left Minister-top-color">基本信息</div>
		</div>
		<div class="information_content">
      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          本地分类
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.categoryFullName"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          中文标题
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.chineseName"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          英文标题
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.englishName"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          品牌
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.brand"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          关键词
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.keyword"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          文字描述
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-html="baseInfo.briefIntroduction"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom:10px;"
           v-for="(item,index) in baseInfo.bluePoint" :key="index">
        <div class="information_Title">
          亮点
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.bluePoint[index]"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div class="information_input" style="margin-bottom:20px;">
        <div class="information_Title">
          备注
        </div>
        <div class="input_el input_span">
          <div class="newipt">
            <el-input type="textarea" :rows="1"
                class="width85"
                v-model="baseInfo.remark"
                :readonly="true"
            >
            </el-input>
          </div>
        </div>
      </div>

		</div>
	</div>
</template>
<script>
	export default {
		name: 'baseInfoComp',
    props: {
      baseInfo: {
        type: Object,
        default: {},
      },
    },
		data() {
			return {}
		},
		created() {
		},
	}
</script>
<style lang="scss" scoped>
	@import "../ozon.less";
</style>
